<template>
  <div class="table-box">
    <div class="table-row border-top">
      <div class="table-title border-left back-grove-light">
        <P>内容</P>
      </div>
      <div class="table-text border-left border-right">
        <textarea rows="10" v-model="remark"></textarea>
      </div>
    </div>
    <div class="table-row border-top">
      <div class="table-title border-left back-grove-light">
        <P>名称</P>
      </div>
      <div class="table-text border-left">
        <input type="text" v-model="name" />
      </div>
      <div class="table-title border-left back-grove-light">
        <p>身份</p>
      </div>
      <div class="table-text border-left border-right">
        <input type="text" v-model="idname" />
      </div>
    </div>
    <div class="table-row border-top">
      <div class="table-title border-left back-grove-light">
        <P>邮箱</P>
      </div>
      <div class="table-text border-left">
        <input type="text" v-model="email" />
      </div>
      <div class="table-title border-left back-grove-light">
        <p>手机(必填)</p>
      </div>
      <div class="table-text border-left border-right">
        <input type="text" v-model="phone" required />
      </div>
    </div>
    <div class="table-row border-top border-bottom">
      <div class="table-text border-left border-right">
        <button type="button" class="back-grove-light" @click="SetAffairIdea">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    affairId: Number,
    default: -1
  },
  data() {
    return {
      phone: "",
      remark: "",
      name: "",
      email: "",
      idname: ""
    };
  },
  methods: {
    SetAffairIdea() {
      if (this.checkForm()) {
        this.$axios({
          url: "api/SetAffairIdea",
          method: "post",
          data: {
            affairId: this.affairId,
            phone: this.phone,
            remark: this.remark,
            name: this.name,
            email: this.email,
            idname: this.idname
          }
        })
          .then(res => {
            if (res.data.flag) {
              this.phone = "";
              this.remark = "";
              this.name = "";
              this.email = "";
              this.idname = "";
            }
          })
          .catch(err => {
            console.info(err);
          });
      }
    },
    checkForm() {
      if (this.affairId < 0) {
        alert("清单编号有误");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        alert("手机号码有误，请重填");
        return false;
      }
      if (this.remark.trim().length <= 0) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped></style>